import { hexToRgb, rgbToHex, lighten, darken, mix } from '../utils/color';

const DEFAULT_COLORS = {
	mainColor: 'rgb(74, 65, 198)',
	textOnMainColor: '#fff',
	lighterBackground: '#664bf0',
	textOnLighterBackground: '#f2bfff',
	textColor: '#6a35ff',
};

export const useBrandColors = (hexColor: string | null) => {
	if (!hexColor) {
		return DEFAULT_COLORS;
	}

	const rgb = hexToRgb(hexColor);
	if (!rgb) {
		return DEFAULT_COLORS;
	}

	const backgroundRgb = darken(rgb, 0.15); // subdued main color
	const lighterBackgroundRgb = lighten(rgb, 0.025); // slightly lightened main color

	const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
	const textRgb =
		luminance > 0.5
			? mix({ r: 0, g: 0, b: 0 }, rgb, 0.2) // dark text with hint of main color
			: mix({ r: 255, g: 255, b: 255 }, rgb, 0.2); // light text with hint of main color

	const mainLuminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
	const textOnMainRgb =
		mainLuminance > 0.5
			? mix({ r: 0, g: 0, b: 0 }, rgb, 0.25) // dark text with hint of main color
			: mix({ r: 255, g: 255, b: 255 }, rgb, 0.2); // light text with hint of main color

	const lighterBackgroundLuminance =
		(0.299 * lighterBackgroundRgb.r + 0.587 * lighterBackgroundRgb.g + 0.114 * lighterBackgroundRgb.b) / 255;
	const textOnLighterBackgroundRgb =
		lighterBackgroundLuminance > 0.5
			? mix({ r: 0, g: 0, b: 0 }, rgb, 0.3) // dark text with hint of main color
			: mix({ r: 255, g: 255, b: 255 }, rgb, 0.2); // light text with hint of main color

	return {
		mainColor: rgbToHex(backgroundRgb),
		lighterBackground: rgbToHex(lighterBackgroundRgb),
		textColor: rgbToHex(textRgb),
		textOnMainColor: rgbToHex(textOnMainRgb),
		textOnLighterBackground: rgbToHex(textOnLighterBackgroundRgb),
	};
};
